import { render, staticRenderFns } from "./gc-product-kits.vue?vue&type=template&id=bb5019a4&"
import script from "./gc-product-kits.vue?vue&type=script&lang=js&"
export * from "./gc-product-kits.vue?vue&type=script&lang=js&"
import style0 from "./gc-product-kits.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports